// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see LocalEditorialLoadEditorialEvent
 */
export var LocalEditorialLoadEditorial = function (_a) {
    var editorialToken = _a.editorialToken, attributionKey = _a.attributionKey, invocationMethod = _a.invocationMethod, buyerType = _a.buyerType, buyerToken = _a.buyerToken;
    return ({
        name: "LocalEditorial Load Editorial",
        parameters: {
            cdf_entity: "LocalEditorial",
            cdf_action: "Load",
            editorial_token: editorialToken !== undefined && editorialToken !== null ? editorialToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attribution_key: attributionKey !== undefined && attributionKey !== null ? attributionKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            invocation_method: invocationMethod !== undefined && invocationMethod !== null ? invocationMethod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            buyer_type: buyerType !== undefined && buyerType !== null ? buyerType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            buyer_token: buyerToken !== undefined && buyerToken !== null ? buyerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
